module.exports = __webpack_public_path__ + "static/media/MZW_04.35de4f91.jpg";